export default defineNuxtRouteMiddleware((to, from) => {
  const config = useRuntimeConfig();
  const publicHtmls = config.public.publicHtmls;
  if (publicHtmls.includes(to.fullPath)) {
    let redirectPath = to.fullPath;
    if (to.fullPath.startsWith("/reactNative_webViewPage/useRule")) {
      redirectPath = "/reactNative_webViewPage/useRule_20250602";
    } else if (
      to.fullPath.startsWith("/reactNative_webViewPage/personalInformation")
    ) {
      redirectPath = "/reactNative_webViewPage/personalInformation_20250307";
    }
    redirectPath += ".html";
    return navigateTo(redirectPath);
  }
});
